import Api from "./api";
import IStorageState from "../interface/storage-state";
import IStorageLatestApps from "../interface/storage-latest-apps";
import Global from "../global";
import StorageItem from "../enum/storage-item";

class StorageInstance {

    private readonly ItemName: string = Global.LOCAL_STORAGE_ITEM_NAME;

    /* Public Methods */

    public getItem<T>(name: StorageItem): T | null {
        const state: IStorageState | null = this.getState();
        if (state && state[name]) {
            return state[name] as T;
        }
        return null;
    }

    public setItem<T>(name: StorageItem, value: T): void {
        const state: IStorageState | null = this.getState();
        if (state) {
            state[name] = value;
            (Api.getLocalStorage() as Storage).setItem(this.ItemName, this.encrypt(state));
        }
    }

    public setLatestApplication(username: string, application: string): void {
        const applications: IStorageLatestApps = this.getItem(StorageItem.LatestApplications) || {};
        applications[username] = application;
        this.setItem(StorageItem.LatestApplications, applications);
    }

    public getLatestApplication(username: string): string | null {
        const latestApps: IStorageLatestApps | null = this.getItem(StorageItem.LatestApplications);
        if (latestApps && latestApps[username]) {
            return latestApps[username];
        }
        return null;
    }

    /* Private Methods */

    private encrypt(data: IStorageState): string {
        const result: string = btoa(JSON.stringify(data)) + this.getMask();
        return result.split('').reverse().join('');
    }

    private decrypt(string: string): IStorageState {
        string = string.split('').reverse().join('');
        string = string.slice(0, string.indexOf(this.getMask()));
        try {
            return JSON.parse(atob(string)) as IStorageState;
        } catch (err) {
            return {};
        }
    }

    private getMask(): string {
        const agent: string = navigator.userAgent;
        const mask: string = btoa(agent.slice(0, agent.length / 2));
        return mask.slice(5, mask.length - 5);
    }

    private getState(): IStorageState | null {
        const storage: Storage | null = Api.getLocalStorage();
        if (storage) {
            const state: string | null = storage.getItem(this.ItemName);
            if (state) {
                return this.decrypt(state);
            }
            return {};
        }
        return null;
    }

}

const Storage = new StorageInstance();

export default Storage;